<template>
  <v-container class="main-container responsive-height create-investor-account-details">
    <v-row dense>
      <v-col cols="12" sm="4" md="4" lg="3">
        <v-card tile flat class="TitleCard mb-3" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-sheet class="mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <h2 class="mt-0">Account</h2>
                  <p class="mb-0">{{ mammanagerstatistics?.username }}({{ mammanagerstatistics?.trading_account_no }})</p>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row dense>
          <v-col cols="12">
            <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
              <div class="user-profile">
                <div class="profile-image">
                  <v-badge avatar bordered overlap color="black accent-4">
                    <span class="numbers">{{ mammanagerstatistics?.manager_rank }}</span>
                    <v-avatar size="47">
                      <v-img
                        :src="mammanagerstatistics?.profile_pic || `https://ui-avatars.com/api/?name=${mammanagerstatistics?.name}&background=random` || require('@/assets/avatar.png')"></v-img>
                    </v-avatar>
                  </v-badge>
                </div>
                <v-btn :disabled="$canRoute('registered-user?tab=1') !== 1" small class="mt-3" elevation="0" plain>
                  <router-link
                    :to="`/registered-user-details/${mammanagerstatistics?.client_account_id}`"
                    class="text-capitalize text--primary">
                    {{ mammanagerstatistics?.name }}
                  </router-link>
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="8" md="8" lg="5">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span>Active Investors</span>
                    <p class="number mb-0">{{ mammanagerstatistics?.investors }} <strong>ACC.</strong></p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">Credit: </span>
                    <b class="ml-1">{{ mammanagerstatistics?.credit }}</b>
                    <br />
                    <span class="mb-2 d-inline-block">Profit Sharing: </span>
                    <b class="ml-1">{{ mammanagerstatistics?.profit_share }}</b> <br />
                    <span class="mb-2 d-inline-block">Pro. Sharing Time: </span>
                    <b class="ml-1">{{ mammanagerstatistics?.profit_sharing_time }}</b>
                  </p>

                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <span class="ml-0">Account Balance</span>
                    <p class="number mb-0">{{ mammanagerstatistics?.balance }} <strong>USD</strong></p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">Leverage: </span>
                    <b class="ml-1">{{ mammanagerstatistics?.leverage }}</b>
                    <br />
                    <span class="mb-2 d-inline-block">Equity: </span> <b class="ml-1">{{ mammanagerstatistics?.equity
                    }}</b>
                    <br />
                    <span class="mb-2 d-inline-block">Currency: </span> <b class="ml-1">USD</b>
                  </p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <manager-details-all-tabs></manager-details-all-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ManagerDetailsAllTabs from '@/components/Mam/ManagerDetailsAllTabs.vue';

import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    ManagerDetailsAllTabs
  },
  computed: {
    ...mapState("mam", ["mammanagerstatistics"]),
  },

  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.GETMAMMANAGERSTATISTICS,
    ]),
  },

  async mounted() {
    await this[MAM__ACTIONS.GETMAMMANAGERSTATISTICS](this.$route.query.account);
  }
}
</script>
